export default {
  code: '',
  name: ''
};
